import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    notificationModal: false,
    chatModal: false,
    loginModal: false,
    changePasswordModal: false,
    forgotPasswordModal: false,
    confirmChangePasswordModal: false,
    confirmCreatedAccount: null,
    confirmForgotPassword: false,
    confirmFailedPassword: false,
    linkSend: false,
    walletModal: false,
    stableNameDetails: null,
    recoveryPassword: null,
    confirmFailedAccount: null
};
const slice = createSlice({
    name: 'modalsState',
    initialState,
    reducers: {
        setNotificationModal: (state, action) => {
            state.notificationModal = action.payload;
        },
        setChatModal: (state, action) => {
            state.chatModal = action.payload;
        },
        setLoginModal: (state, action) => {
            state.loginModal = action.payload;
        },
        setChangePasswordModal: (state, action) => {
            state.changePasswordModal = action.payload;
        },
        setForgotPasswordModal: (state, action) => {
            state.forgotPasswordModal = action.payload;
        },
        setConfirmChangePasswordModal: (state, action) => {
            state.confirmChangePasswordModal = action.payload;
        },
        setConfirmCreatedAccountModal: (state, action) => {
            state.confirmCreatedAccount = action.payload;
        },
        setConfirmPasswordModal: (state, action) => {
            state.confirmForgotPassword = action.payload;
        },
        setConfirmPasswordFailedModal: (state, action) => {
            state.confirmFailedPassword = action.payload;
        },
        setLinkSendModal: (state, action) => {
            state.linkSend = action.payload;
        },
        setWalletModal: (state, action) => {
            state.walletModal = action.payload;
        },
        setStableDetails: (state, action) => {
            state.stableNameDetails = action.payload;
        },
        setRecoveryPassword: (state, action) => {
            state.recoveryPassword = action.payload;
        },
        setFailedAccountModal: (state, action) => {
            state.confirmFailedAccount = action.payload;
        }
    }
});
export const { setNotificationModal, setChatModal, setChangePasswordModal, setForgotPasswordModal, setConfirmChangePasswordModal, setConfirmCreatedAccountModal, setConfirmPasswordModal, setConfirmPasswordFailedModal, setLinkSendModal, setWalletModal, setStableDetails, setRecoveryPassword, setFailedAccountModal, setLoginModal } = slice.actions;
export default slice.reducer;
